import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { formatDate } from '../../lib/utils';

export function DispatchViewDialog({
  open,
  onOpenChange,
  dispatch,
  medications
}) {
  if (!dispatch) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Detalles del Despacho</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="text-slate-500">No. Despacho</p>
              <p className="font-mono font-bold text-[#931A25]">{dispatch.dispatch_number}</p>
            </div>
            <div>
              <p className="text-slate-500">Fecha</p>
              <p className="font-medium">{formatDate(dispatch.dispatch_date)}</p>
            </div>
            <div>
              <p className="text-slate-500">Proyecto</p>
              <p className="font-medium">{dispatch.project_name}</p>
            </div>
            <div>
              <p className="text-slate-500">Nave / Lote</p>
              <p className="font-medium">
                Nave {dispatch.nave_number} / Lote {dispatch.lote_number}
              </p>
            </div>
          </div>
          
          <div>
            <p className="text-slate-500 text-sm mb-2">Items Despachados</p>
            <div className="border rounded-lg overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow className="bg-slate-50">
                    <TableHead>Item</TableHead>
                    <TableHead>Tipo</TableHead>
                    <TableHead className="text-right">Cantidad</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {dispatch.items.map((item, index) => {
                    const isPremix = item.is_premix || (item.item_type === 'medicamento' && 
                      medications.find(m => m.id === item.item_id)?.administration_type === 'premix');
                    
                    return (
                      <TableRow key={index}>
                        <TableCell className="font-medium">
                          {item.item_name}
                          {isPremix && (
                            <span className="ml-2 bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded text-xs font-medium">
                              Premix
                            </span>
                          )}
                        </TableCell>
                        <TableCell>
                          <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs ${
                            item.item_type === 'alimento' 
                              ? 'bg-green-100 text-green-700' 
                              : isPremix
                                ? 'bg-purple-100 text-purple-700'
                                : 'bg-blue-100 text-blue-700'
                          }`}>
                            {item.item_type === 'alimento' ? 'Alimento' : isPremix ? 'Premix' : 'Medicamento'}
                          </span>
                        </TableCell>
                        <TableCell className="text-right">{item.quantity} {item.unit}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          </div>
          
          <div className="flex justify-between items-center bg-slate-50 p-3 rounded-lg">
            <span className="font-medium">Total Alimento Despachado</span>
            <span className="font-bold text-lg text-[#931A25]">
              {(() => {
                const alimentoQty = dispatch.items
                  .filter(i => i.item_type === 'alimento')
                  .reduce((sum, i) => sum + (i.quantity || 0), 0);
                return alimentoQty.toFixed(2);
              })()} qq
            </span>
          </div>
          
          {dispatch.notes && (
            <div>
              <p className="text-slate-500 text-sm">Notas</p>
              <p className="text-sm">{dispatch.notes}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
